import limaApi from './lima-api.js';

const resources = [
  {lang:['ja'], url:'/resources/i18n/locale-ja.json'},
  {lang:['en'], url:'/resources/i18n/locale-en.json'},
];

let preferred = {};
let fallback = {};

function limaTranslate(id, options) {
  let msg = _.get(preferred.data, id);
  if (typeof msg !== 'string') {
    console.warn(`translate(${preferred.lang[0]}): "${id}" is missing`);
    if (preferred !== fallback) {
      msg = _.get(fallback.data, id);
      if (!msg) console.warn(`translate(${fallback.lang[0]}): "${id}" is missing`);
    }
  }
  if (typeof msg === 'string' && options && typeof options === 'object') {
    Object.keys(options).forEach(key => {
      switch (typeof options[key]) {
        case 'number': case 'string': return msg = msg.replace(new RegExp(`{{${key}}}`, 'g'), '' + options[key]);
        default: return;
      }
    });
  }
  return typeof msg === 'string' ? msg : '';
}

limaTranslate.load = async ({preferredLang = 'ja', fallbackLang = 'en'} = {}) => {
  let idx1 = _.findIndex(resources, resource => _.includes(resource.lang, preferredLang));
  preferred = resources[idx1] || {lang:[preferredLang]};
  if (!preferred.url && typeof preferredLang === 'string') {
    preferredLang = preferredLang.slice(0, 2);
    preferred = _.find(resources, resource => _.includes(resource.lang, preferredLang)) || {lang:[preferredLang]};
  }
  if (preferred.url && !preferred.data) {
    preferred.data = await limaApi.get(preferred.url).then(res => res.data, err => {
      console.warn('failed to load preferred resource', preferred.url, err);
    });
  }
  let idx2 = _.findIndex(resources, resource => _.includes(resource.lang, fallbackLang));
  if (idx1 === idx2) idx2 = (idx1 + 1) % resources.length;
  fallback = resources[idx2] || {lang:[fallbackLang]};
  if (!fallback.url && typeof fallbackLang === 'string') {
    fallbackLang = fallbackLang.slice(0, 2);
    fallback = _.find(resources, resource => _.includes(resource.lang, fallbackLang)) || {lang:[fallbackLang]};
  }
  if (fallback.url && !fallback.data) {
    fallback.data = await limaApi.get(fallback.url).then(res => res.data, err => {
      console.warn('failed to load fallback resource', fallback.url, err);
    });
  }
}

Object.defineProperty(limaTranslate, 'locale', {get:() => _.first(preferred.lang) || _.first(fallback.lang)});

export {limaTranslate as default};
